import { render, staticRenderFns } from "./SelectProviderChooser.vue?vue&type=template&id=9524c09c"
import script from "./SelectProviderChooser.vue?vue&type=script&lang=js"
export * from "./SelectProviderChooser.vue?vue&type=script&lang=js"
import style0 from "./SelectProviderChooser.vue?vue&type=style&index=0&id=9524c09c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports